import { Component, OnInit,Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgxSpinnerService } from 'ngx-spinner';




@Component({
  selector: 'app-confirmation-medical',
  templateUrl: './confirmation-medical.component.html',
  styleUrls: ['./confirmation-medical.component.css']
})
export class ConfirmationMedicalComponent implements OnInit {
  success = '';
  medicalTest='';
  
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private _snackBar: MatSnackBar,
    private spinner: NgxSpinnerService,
    public dialog: MatDialog,) {
      
    this.success = this.route.snapshot.paramMap.get('status')
    this.medicalTest = this.route.snapshot.paramMap.get('result')
   }

   
  ngOnInit() {
    if(!(this.success === 'success' ||  this.success === 'fail')){
      this.router.navigate(['/404']);
    }
  }

}
